import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "ecfc964a-84ac-4834-97e9-2da586c2f1f2", //in the future might want to get this info from backend
        authority: "https://login.microsoftonline.com/common",
        redirectUri: window.location.origin + "/login",
    }
};

// Create the instance once
export let msalInstance = null;

let isInitialized = false;
export const initializeMsal = async () => {
    if (!isInitialized) {
        const { PublicClientApplication } = await import("@azure/msal-browser");
        msalInstance = new PublicClientApplication(msalConfig);

        await msalInstance.initialize();
        isInitialized = true;
    }
};